import "jquery"
import { LocalStorageCache } from "./LocalStorageCache";

export class AjaxOptions implements JQueryAjaxSettings {
    url: string;
    contentType: string;
    method: string;
    data: JQuery.PlainObject<Object> | string;
    constructor(url: string, method?: string, data?: Object, contentType?: string) {
        this.url = url;
        this.method = method || "get";
        this.data = ((data || {}) as any);
    }
}

export class AjaxService {
    private static instance: AjaxService;
    public static getInstance() { return AjaxService.instance || (AjaxService.instance = new AjaxService()); }

    public request = (options: JQueryAjaxSettings, successCallback: Function, errorCallback?: Function, cacheKey : string = null, useFormData = false): void  => {

        if (cacheKey) {
            LocalStorageCache.getInstance().getOrBuild(
                    options.url,
                    () => new Promise((resolve, reject) => {
                        $.ajax({
                            contentType: options.contentType,
                            url: options.url,
                            type: options.method,
                            data: options.data,
                            cache: false,
                            success(d) {
                                resolve(d);
                            },
                            error(d) {
                                reject(d);
                            }
                        });

                    }),
                    () => [cacheKey]
                )
                .then(result => successCallback(result))
                .catch(error => {
                    if (errorCallback) {
                        errorCallback(error);
                    }
                });
        } else if (useFormData) {
            $.ajax({
                contentType: false,
                url: options.url,
                type: options.method,
                data: options.data,
                cache: false,
                processData: false,
                success(d) {
                    successCallback(d);
                },
                error(d) {
                    if (errorCallback) {
                        errorCallback(d);
                        return;
                    }
                }
            });
        } else {
            $.ajax({
                contentType: options.contentType,
                url: options.url,
                type: options.method,
                data: options.data,
                cache: false,
                success(d) {
                    successCallback(d);
                },
                error(d) {
                    if (errorCallback) {
                        errorCallback(d);
                        return;
                    }
                }
            });
        }
    }
    public getWithContentType = (url: string, contentType: string, successCallback: Function, errorCallback?: Function, cacheKey: string = null): void => {
        this.request(new AjaxOptions(url,null,null,contentType), successCallback, errorCallback, cacheKey);
    }
    public get = (url: string, successCallback: Function, errorCallback?: Function, cacheKey: string = null): void => {
        this.request(new AjaxOptions(url), successCallback, errorCallback, cacheKey);
    }
    public getWithDataInput = (url: string, data: Object, successCallback: Function, errorCallback?: Function, cacheKey: string = null): void => {
        this.request(new AjaxOptions(url, "get", data), successCallback, errorCallback, cacheKey);
    }
    public post = (url: string, successCallback: Function, errorCallback?: Function, cacheKey: string = null): void => {
        this.request(new AjaxOptions(url, "post"), successCallback, errorCallback, cacheKey);
    }
    public postWithData = (url: string, data: Object, successCallback: Function, errorCallback?: Function, cacheKey: string = null): void => {
        this.request(new AjaxOptions(url, "post", data), successCallback, errorCallback, cacheKey);
    }
    public postWithFormData = (url: string, data: Object, successCallback: Function, errorCallback?: Function, cacheKey: string = null): void => {
        this.request(new AjaxOptions(url, "post", data), successCallback, errorCallback, cacheKey, true);
    }
}
